/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesRole } from './WebApiModelsEnumerationTypesRole';
import {
    WebApiModelsEnumerationTypesRoleFromJSON,
    WebApiModelsEnumerationTypesRoleFromJSONTyped,
    WebApiModelsEnumerationTypesRoleToJSON,
} from './WebApiModelsEnumerationTypesRole';

/**
 * 
 * @export
 * @interface WebApiCompanyDtoCompanyUpdateUserDto
 */
export interface WebApiCompanyDtoCompanyUpdateUserDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCompanyDtoCompanyUpdateUserDto
     */
    id?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesRole}
     * @memberof WebApiCompanyDtoCompanyUpdateUserDto
     */
    role?: WebApiModelsEnumerationTypesRole;
}

/**
 * Check if a given object implements the WebApiCompanyDtoCompanyUpdateUserDto interface.
 */
export function instanceOfWebApiCompanyDtoCompanyUpdateUserDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCompanyDtoCompanyUpdateUserDtoFromJSON(json: any): WebApiCompanyDtoCompanyUpdateUserDto {
    return WebApiCompanyDtoCompanyUpdateUserDtoFromJSONTyped(json, false);
}

export function WebApiCompanyDtoCompanyUpdateUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCompanyDtoCompanyUpdateUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'role': !exists(json, 'role') ? undefined : WebApiModelsEnumerationTypesRoleFromJSON(json['role']),
    };
}

export function WebApiCompanyDtoCompanyUpdateUserDtoToJSON(value?: WebApiCompanyDtoCompanyUpdateUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'role': WebApiModelsEnumerationTypesRoleToJSON(value.role),
    };
}

